import React from "react";
import { Typography, Box, Chip } from "@mui/material";
import { formatNumber } from "helpers/getNumberFormats";

const cardBaseStyle = {
  borderRadius: 8,
  padding: 12,
  display: "flex",
  flexDirection: "column",
  gap: 4,
};

/**
 * Tarjeta de un registro del historial (o del estado actual).
 */
const ChangeCard = ({ date, origin, percentage, reason, username, isCurrent }) => (
  <Box
    style={{
      ...cardBaseStyle,
      border: isCurrent ? "2px solid #1976d2" : "1px solid rgba(0, 0, 0, 0.12)",
      backgroundColor: isCurrent ? "rgba(25, 118, 210, 0.06)" : "transparent",
    }}
  >
    <Box style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      <Box style={{ display: "flex", alignItems: "center", gap: 8 }}>
        {!isCurrent ? (
          <Typography variant="subtitle2" style={{ fontWeight: 600 }}>
            {date?.replace(/\.0+$/, "")}
          </Typography>
        ) : null}
        {isCurrent ? (
          <Chip label="Actual" size="small" color="primary" />
        ) : null}
      </Box>
      <Chip label={origin || "—"} size="small" variant="outlined" />
    </Box>
    <Typography variant="body2">
      Porcentaje: <strong>{formatNumber(percentage)}%</strong>
    </Typography>
    {reason ? (
      <Typography variant="body2" color="textSecondary">
        Razón: {reason}
      </Typography>
    ) : null}
    {username ? (
      <Typography variant="caption" color="textSecondary">
        Usuario: {username}
      </Typography>
    ) : null}
  </Box>
);

/**
 * Muestra el historial de cambios de porcentaje (percentChanges) de un
 * inventario, incluyendo el estado actual resaltado como el más reciente.
 */
export const PercentChangesHistory = ({ data }) => {
  const {
    percentChanges = [],
    percentage,
    tank,
    unit,
    origin,
    username,
    closureDate,
    inventoryReason,
  } = data || {};

  return (
    <Box style={{ width: "100%" }}>
      <Box style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 16 }}>
        <Chip label={`Unidad: ${unit || "—"}`} size="small" />
        <Chip label={`Tanque: ${tank || "—"}`} size="small" />
      </Box>

      <Box style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {/* Estado actual siempre arriba */}
        <ChangeCard
          date={closureDate}
          origin={origin}
          percentage={percentage}
          reason={inventoryReason}
          username={username}
          isCurrent
        />

        {/* Historial de cambios ordenado por fecha descendente (más reciente primero) */}
        {[...percentChanges]
          .sort((a, b) => new Date(b.date) - new Date(a.date))
          .map((change, idx) => (
            <ChangeCard
              key={`${change.date}-${idx}`}
              date={change.date}
              origin={change.origin}
              percentage={change.previousPercentage}
              reason={change.reason}
              username={change.username}
            />
          ))}
      </Box>
    </Box>
  );
};
